<div class="or-px-32-px or-pt-32-px or-head-lg or-text-align-center">{{ header }}</div>

<ion-radio-group (ionChange)="setData($event)" [value]="selectedDataSignal()">
  <div class="or-px-32-px or-pt-20-px or-pb-16-px modal-scroll-area">
    @for (item of providedDataSignal(); track item.value) {
      <ion-radio
        [value]="item.value"
        labelPlacement="end"
        alignment="center"
        justify="start"
        class="or-p-16-px or-mb-8-px or-w-100-pc"
        [ngClass]="isSelected(item.value) ? 'is-active or-bg-focus or-color-main-1' : 'is-no-active or-bg-white'">
        <div class="or-d-flex or-align-items-center or-justify-content-between or-w-100-pc">
          <div class="or-head-sm" [ngClass]="isSelected(item.value) ? 'or-color-main-1' : 'or-color-black'">
            {{ item.name }}
          </div>
          @if (item.description) {
            <div class="radio-item-badge">{{ item.description }}</div>
          }
        </div>
      </ion-radio>
    }
  </div>
</ion-radio-group>

<div class="or-d-flex or-justify-content-center">
  <button
    class="button-primary-style or-h-48-px or-w-60-pc or-head-md or-mb-32-px"
    [disabled]="!hasSelection()"
    [class.disabled-button]="!hasSelection()"
    (click)="closeModal()">
    {{ buttonText }}
  </button>
</div>
